const addHandleKeyDown = editor => {
  editor.on('keydown', e => {
    // Backspace/Delete
    if ([8, 46].includes(e.keyCode)) {
      const selectDom = editor.selection.getNode()
      if (selectDom.nodeName === 'PRE' && !selectDom.textContent.trim()) {
        editor.dom.remove(selectDom)
      }
    }
  })
}
export default addHandleKeyDown
